import { ForbiddenComponent } from './forbidden/forbidden.component';
import { NgModule } from '@angular/core';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    exports: [UnauthorizedComponent, ForbiddenComponent],
    declarations: [UnauthorizedComponent, ForbiddenComponent]

})
export class ExceptionsModule {

}
